// extracted by mini-css-extract-plugin
module.exports = {"badge":"VerificationBadge__badge___Sry73","small":"VerificationBadge__small___3-kBJ","medium":"VerificationBadge__medium___1DJnL"};